import './App.css'

import RouterProvider from './routes/RouterProvider'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
// import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      {/* <LocalizationProvider dateAdapter={AdapterDateFns}> */}
        <RouterProvider />
      {/* </LocalizationProvider> */}
    </QueryClientProvider>
  )
}

export default App
